import './styles/style';
import './string-polyfill';
import spotifyApi from './spotify-api';
import appleMusicApi from './apple-music-api';
import Cookies from 'js-cookie';
import { uuid } from 'uuidv4';
import queryString from 'query-string';
import 'whatwg-fetch';

function getUserId() {
  let user_id = Cookies.get('linkchase_user_id');
  if (!user_id) {
    user_id = uuid();
    Cookies.set('linkchase_user_id', user_id, { expires: 3650 });
  }
  return user_id;
}

function injectCollectImage(event, eventTarget) {
  if (!window.__linkchase_params__) {
    return;
  }

  const analyticsRoot = window.__linkchase_analytics_root__;
  const params = window.__linkchase_params__;
  params.v = Math.floor(Math.random() * Math.floor(1000000)); // to supress browser cache
  params.referrer = document.referrer;
  params.user_id = getUserId();
  if (event) {
    params.event = event;
  }
  if (eventTarget) {
    params.event_target = eventTarget;
  }

  const query = queryString.stringify(params);

  const img = document.createElement('img');
  img.src = `${analyticsRoot}/collect?${query}`;

  document.body.appendChild(img);
}

function createAppleMusicPreAdd(target) {
  const music = MusicKit.getInstance();
  const apiRoot = window.__linkchase_api_root__;
  const params = window.__linkchase_params__;

  const appleMusicPreAdd = document.getElementById('apple-music-pre-add');
  const id = appleMusicPreAdd.dataset.albumid.replace('id', '');

  let promise = null;
  if (target == null || target == 'my-library') {
    promise = music.api.addToLibrary({ albums: [id] });
  } else {
    promise = music.api.album(id).then((album) => {
      return appleMusicApi.addTrackToPlaylist(target, album.relationships.tracks.data);
    });
  }
  return promise.then(() => {
    return fetch(`${apiRoot}/apple_music/pre_add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user_id: getUserId(),
        page_id: params.page_id,
        user_token: music.api.userToken,
        target
      })
    });
  });
}

function createSpotifyPreAdd(target) {
  const apiRoot = window.__linkchase_api_root__;
  const params = window.__linkchase_params__;
  return fetch(`${apiRoot}/spotify/pre_add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      user_id: Cookies.get('linkchase_spotify_uid'),
      page_id: params.page_id,
      target: target,
    })
  }).then(response => {
    if (!response.ok) {
      console.error('response.ok:', response.ok);
      console.error('response.status:', response.status);
      console.error('response.statusText:', response.statusText);
      return response.json().then((r) => {
        throw new Error(r.message);
      });
    }
    return response.json();
  });
}

document.addEventListener('DOMContentLoaded', () => injectCollectImage('view'));

function getMetaTagContent(name) {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === name) {
      return metas[i].getAttribute('content');
    }
  }
  return null;
}

window.onload = function() {
  const params = window.__linkchase_params__;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const links = document.getElementsByTagName('a');
  [].forEach.call(links, (link) => {
    link.addEventListener('click', (e) => {
      injectCollectImage('click', link.dataset.label);
      if (!isIOS) {
        return;
      }
      const href = e.target.href || e.target.parentElement.href;
      if (href && href.startsWith('https://itunes.apple.com') && href.includes('app=itunes')) {
        window.location = href.replace('https://', 'itmss://');
        e.preventDefault();
      }
    });
  });


  const preAddPageId = Cookies.get('linkchase_pre_add_page_id');
  const preAddState = Cookies.get('linchase_pre_add_state');

  console.log(`preAddPageId ${preAddPageId}`);
  console.log(`preAddState ${preAddState}`);

  if (preAddPageId == params.page_id && preAddState == 'completed') {
    showSpotifyTargetPopup();
  }
};

function closePopup() {
  const popup = document.getElementById('popup');
  const popupCloseButton = document.getElementById('popup-close-button');
  const popupBg = document.getElementById('popup-bg');
  popup.className = 'popup';
  popupCloseButton.removeEventListener('click', closePopup);
  popupBg.removeEventListener('click', closePopup);
  Cookies.remove('linkchase_pre_add_page_id');
  Cookies.remove('linchase_pre_add_state');
};

function setupPopup() {
  const popupCloseButton = document.getElementById('popup-close-button');
  const popupBg = document.getElementById('popup-bg');
  if (popupCloseButton) {
    popupCloseButton.addEventListener('click', closePopup);
  }
  if (popupBg) {
    popupBg.addEventListener('click', closePopup);
  }
}

function showPopup(title, content) {
  setupPopup();
  const popup = document.getElementById('popup');
  const popupTitle = document.getElementById('popup-title');
  const popupContent = document.getElementById('popup-content');
  popup.className = 'popup popup-active';
  popupTitle.innerHTML = title;
  popupContent.innerHTML = content;

  const buttons = popupContent.getElementsByClassName('popup-button');
  [].forEach.call(buttons, (button) => {
    button.addEventListener('click', (e) => {
      const expiresAt = Number(e.target.dataset.expiresAt * 1000);
      if (Date.now() > expiresAt) {
        e.preventDefault();
        alert("ダウンロード期限が切れました。ブラウザを再読み込みしてください。");
      }
    });
  });
  const listItems = popupContent.getElementsByClassName('popup-list-item');
  [].forEach.call(listItems, (listItem) => {
    listItem.addEventListener('click', (e) => {
      const service = e.target.dataset.service;
      const target = e.target.dataset.target;

      if (service == 'apple-music') {
        const appleMusicPreAdd = document.getElementById('apple-music-pre-add');
        createAppleMusicPreAdd(target).then(() => {
          return showPreAddCompletionPopup('apple-music', appleMusicPreAdd.dataset.url);
        }, (e) => {
          alert(e.message);
          console.log(e);
        });
      } else {
        createSpotifyPreAdd(target)
          .then((result) => {
            return showPreAddCompletionPopup(service);
          }, (e) => {
            alert(e.message);
            console.log(e);
          });
      }
    });
  });
}

function popupButton(url, title, className) {
  return `<a href="${url}" target="_blank" class="popup-button ${className}">${title}</a>`;
}

document.addEventListener('musickitloaded', function() {
  MusicKit.configure({
    developerToken: getMetaTagContent('apple-music-developer-token'),
    app: {
      name: getMetaTagContent('apple-music-app-name'),
      build: getMetaTagContent('apple-music-app-build-name')
    }
  });
  const appleMusicPreAdd = document.getElementById('apple-music-pre-add');
  if (appleMusicPreAdd) {
    let music = MusicKit.getInstance();
    appleMusicPreAdd.addEventListener('click', (e) => {
      let id = appleMusicPreAdd.dataset.albumid.replace('id', '');
      let url = appleMusicPreAdd.dataset.url;
      if (!id && url) {
        window.open(url);
        return;
      }
      let unauthroize = Promise.resolve();
      if (MusicKit.getInstance().isAuthorized) {
        unauthroize = Promise.all([
          music.unauthorize(),
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
        ]);
      }
      unauthroize.then(() => {
        return music.authorize();
      }).then(() => {
        console.log('succeeded in adding to library');
        showAppleMusicTargetPopup(music);
      }, (e) => {
        console.log(e);
      });
    });
  }

});

function showPreAddCompletionPopup(service, url) {
  const apiRoot = window.__linkchase_api_root__;
  const params = window.__linkchase_params__;
  return fetch(`${apiRoot}/pages/${params.page_id}/pre_add_completion_rewards`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ page_id: params.page_id })
  }).then((response) => response.json())
  .then((rewards) => {
    showPopup(
      preAddCompletionTitle(service),
      preAddCompletionContent(service, url, rewards)
    );
  });
}

function preAddCompletionTitle(service) {
  switch (service) {
    case 'spotify':
      return 'Spotify Pre-Save受付が完了しました。';
    case 'apple-music':
      return 'Apple Music Pre-Add受付が完了しました。';
    default:
      return 'Pre-Add受付が完了しました。';
  }
}

function preAddCompletionContent(service, url, rewards) {
  let content = preAddCompletionMessage(service);
  switch (service) {
    case 'apple-music':
      content += popupButton(url, 'Apple Musicを開く', 'apple-music');
  }
  let button = preAddCompletionUrlButton();
  if (button) {
    content += button;
  }
  rewards.forEach((reward) => {
    content += preAddRewardButton(reward);
  });
  return content;
}

function preAddCompletionMessage(service) {
  let message = '';
  switch (service) {
    case 'spotify':
      message += '<p>リリース後My Libraryにアルバムが追加されます。</p>';
      break;
    case 'apple-music':
      message += '<p>リリース後ライブラリにアルバムが追加されます。</p>';
      message += '<p>先行配信曲はライブラリに追加されましたので、AppleMusic上でお楽しみください。</p>';
      break;
  }
  const elem = document.getElementById('pre-add-completion-message');
  if (elem && elem.innerHTML.trim().length > 0) {
    message = elem.innerHTML;
  }
  return message;
}

function preAddCompletionUrlButton() {
  const elem = document.getElementById('pre-add-completion');
  if (!elem || !elem.dataset.linkLabel || !elem.dataset.linkUrl) {
    return null;
  }
  return popupButton(elem.dataset.linkUrl, elem.dataset.linkLabel, '');
}

function preAddRewardButton(reward) {
  const title = reward.title || '特典をダウンロード';
  return `<a href="${reward.url}" class="popup-button" data-expires-at="${reward.expires_at}">${title}</a>`;
}

function showSpotifyTargetPopup(token) {
  const userId = Cookies.get('linkchase_spotify_uid');
  return spotifyApi.retrievePlaylists(token)
    .then((resp) => {
      const items = [
        '<li class="popup-list-item" data-service="spotify" data-target="my-library">マイライブラリ</li>'
      ];
      // resp.items.forEach((item) => {
      //   if (item.owner.id == userId) {
      //     items.push(`<li class="popup-list-item" data-service="spotify" data-target="${item.id}">${item.name}</li>`);
      //   }
      // });
      showPopup(
        '追加先を選択してください',
        '<ul class="popup-list">' + items.join('') + '</ul>' +
          `<a href="" target="_blank" class="popup-button">キャンセル</a>`,
      );
    });
}

function showAppleMusicTargetPopup() {
  let music = MusicKit.getInstance();
  return music.api.library.playlists().then((playlists) => {
    const items = [
      '<li class="popup-list-item" data-service="apple-music" data-target="my-library">マイライブラリ</li>'
    ];
    playlists.forEach((item) => {
      if (item.attributes.canEdit) {
        items.push(`<li class="popup-list-item" data-service="apple-music" data-target="${item.id}">${item.attributes.name}</li>`);
      }
    });
    showPopup(
      '追加先を選択してください',
      '<ul class="popup-list">' + items.join('') + '</ul>' +
        `<a href="" target="_blank" class="popup-button">キャンセル</a>`,
    );
  });
}
